import { render, staticRenderFns } from "./EventsInfo.vue?vue&type=template&id=3e47af62&scoped=true&"
import script from "./EventsInfo.vue?vue&type=script&lang=js&"
export * from "./EventsInfo.vue?vue&type=script&lang=js&"
import style0 from "./EventsInfo.vue?vue&type=style&index=0&id=3e47af62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e47af62",
  null
  
)

export default component.exports